import { Component, OnInit } from '@angular/core';
import { MemberService } from '../../core/services/member.service';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

interface UserProfile {
  _id: string;
  name: string;
  email: string;
  status: string;
  regCode: string;
  mobileNo: string;
  description: string;
  grade: string;
  position: string;
  residence: string;
  workplace: string;
  profilePicture: { url: string } | null;
  phoneNo: string;
}

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.scss'],
})
export class UsersComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Members',
    },
  ];

  user: UserProfile = {
    _id: '',
    name: '',
    email: '',
    status: '',
    regCode: '',
    mobileNo: '',
    description: '',
    position: '',
    grade: '',
    residence: '',
    workplace: '',
    profilePicture: null,
    phoneNo: '',
  };

  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 5;
  searchValue = '';

  constructor(
    private memberService: MemberService,
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.user = this.authService.getLoggedInUser();
    this.loadMembers();
  }

  loadMembers(): void {
    this.memberService
      .getMembers(this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  getMembersBySearch(): void {
    this.memberService
      .getMembersBySearch(this.searchValue, this.currentPage, this.pageSize)
      .then((response) => {
        this.data = response.docs;
        this.totalDocs = response.totalDocs;
      });
  }

  onCurrentPageDataChange(page: any): void {
    this.currentPage = page;
    this.loadMembers();
  }

  cancelSearch(): any {
    this.searchValue = '';
    this.currentPage = 1;
    this.loadMembers();
  }

  viewMember(id: any): void {
    this.router.navigate(['/admin/member-view/', { id }]);
  }

  onImageProfile(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = 'assets/img/avatar_image.jpg';
  }
}
